import _ from "lodash";
import { ILiteTradeAsset, ILiteTradeMarketDataCandleTimeItem } from '../types/liteTradeReducer.t';

export const getMarketDataCandleSymbolLastPriceParams = (marketDataCandleItem: ILiteTradeMarketDataCandleTimeItem, asset?: ILiteTradeAsset) => {
    if (!marketDataCandleItem) {
        return null;
    }
    const keys = Object.keys(marketDataCandleItem).sort();
    const firstCandleTime = keys[keys.length - 2];
    const firstCandle = marketDataCandleItem[firstCandleTime];
    const lastCandleTime = keys[keys.length - 1];
    const lastCandle = marketDataCandleItem[lastCandleTime];
    if (!lastCandle || isNaN(lastCandle.close) || !firstCandle || isNaN(firstCandle.close) || _.isNull(lastCandle.close) || _.isNull(firstCandle.close)) {
        return null;
    }
    const diffAmount = lastCandle.close - firstCandle.close;
    const diffPercent = diffAmount / firstCandle.close * 100;
    return {
        diffAmount,
        diffPercent,
        close: asset && lastCandle.close
            ? lastCandle.close.toFixed(-Math.log10(asset.info.priceIncrement))
            : null,
    };
};
